export default "<div\r\n  class=\"mat-title\"\r\n  [innerHTML]=\"text\"\r\n></div>\r\n"